<template>
  <div class="teacher-list">
    <el-table
      ref="multipleTable"
      :data="teacherList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55px"> </el-table-column>
      <el-table-column
        prop="teacherName"
        width="120px"
        :show-overflow-tooltip="true"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="sex"
        width="120px"
        :show-overflow-tooltip="true"
        label="性别"
      >
      </el-table-column>
      <el-table-column
        prop="teacherNumber"
        width="160px"
        :show-overflow-tooltip="true"
        label="工号"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号(账号)"
        width="120px"
      ></el-table-column>
      <el-table-column
        prop="entryDate"
        label="入职时间"
        width="100px"
      ></el-table-column>
      <el-table-column prop="resume" label="职务">
        <template slot-scope="scope">
          {{ scope.row.jobName }}
        </template></el-table-column
      >
      <el-table-column label="操作" width="400px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button
              size="small"
              type="primary"
              @click="resetPassword(scope.row)"
              style="border: none;"
              >重置密码</el-button
            >
            <!-- 权限绑定 -->
            <el-button
              size="small"
              type="primary"
              icon="el-icon-paperclip"
              @click="bindClick(scope.row)"
              v-hasPermi="'sc:classpower:list'"
              style="border: none;"
            >班级数据权限</el-button>
            <!-- 修改 -->
            <el-button
              size="small"
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:teacher:edit'"
              style="border: none;"
            >修改
            </el-button>
            <!-- 删除 -->
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              v-hasPermi="'sc:teacher:delete'"
              style="border: none;"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <teacherEdit
      :dialogVisible.sync="editShow"
      :teacherInfo="teacherInfo"
      v-show="editShow"
    />
    <teacherPermissionBind
      :dialogVisible.sync="bindShow"
      :teacherInfo="teacherInfo"
      v-if="bindShow"
      :gradeList="gradeList"
      @insertClassPower="insertClassPower"
    />
  </div>
</template>

<script>
import teacherEdit from "../teacher-edit/teacher-edit.vue";
import teacherPermissionBind from "../teacher-permission-bind/teacher-permission-bind.vue";

export default {
  name: "",
  props: {
    teacherList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  inject: ["refresh"],
  data() {
    return {
      teacherInfo: {},
      editShow: false,
      bindShow: false,
      selectList: [],
      gradeList: [],
    };
  },
  components: {
    teacherEdit,
    teacherPermissionBind,
  },
  created() {
    this.getGradeList();
  },
  methods: {
    resetPassword(row) {
      this.$confirm(
        "是否重置该教师的密码为默认密码（LanYue123456）？",
        "重置密码",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          confirmButtonClass: "confirm",
        }
      )
        .then(() => {
          // 调用接口，重置教师密码
          this.post(this.$url.resetPassword, {
            id: row.id,
          })
            .then((res) => {
              // console.log(res)
              if (res.code == 200 && res.data > 0) {
                this.$message.success("教师密码重置成功");
              } else {
                this.$message.error("重置失败");
              }
            })
            .catch((err) => {
              // console.log(err)
              this.$message.error("重置失败，请稍后再试");
            });
        })
        .catch((err) => {});
    },
    insertClassPower(data) {
      // console.log(data);
      const PermissionBindArray = data.map((item) => {
        const PermissionBindItem = { ...item }; // Create a shallow copy of the object

        for (const key in PermissionBindItem) {
          if (key === "isChecked") {
            delete PermissionBindItem[key]; // Delete the isChecked property
          } else if (typeof PermissionBindItem[key] === "boolean") {
            PermissionBindItem[key] = PermissionBindItem[key] ? 1 : 0;
          }
        }

        return PermissionBindItem;
      });
      // console.log("PermissionBindArray:", PermissionBindArray);
      this.post(this.$url.insertClassPower, PermissionBindArray).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.bindShow = false;
          this.refresh();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取年级
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            res.data.forEach((item) => {
              // 为每个itemC添加checkList对象
              item.schoolClassList.forEach((itemC) => {
                itemC.checkList = {
                  classId: itemC.classId,
                  isAdd: false,
                  isEdit: false,
                  isDelete: false,
                  isView: false,
                  isChecked: false,
                };
              });
            });
            this.gradeList = res.data;
          } else {
            return this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取年级信息失败，请稍后再试");
        });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    bindClick(item) {
      this.teacherInfo = item;
      this.bindShow = true;
    },
    editClick(item) {
      this.teacherInfo = item;
      this.editShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该教师信息?", "删除教师", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除管理员删除教师信息接口
          let list = [];
          list.push(item.id);
          this.post(this.$url.deleteTeacher, list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher-list.scss";
</style>
